export const defaultItemsFilters = {}
export const defaultStockFBSFilters = {
  marketplace_id: 1
}
export const defaultStockSuppliersFilters = {
  done: 1
}
export const defaultAnalyticsFilters = {};
